import { toast } from 'react-toastify';

import ModalConfirm from '@features/modal-confirm';
import { useModal } from '@shared/components/Modal';
import { TUseMutationTrigger } from '@shared/types/fetch-data';

interface IProps<TQuery, TResponse> {
  id: string;
  message: string;
  entityName?: string;
  deleteEntity: TUseMutationTrigger<TQuery, TResponse>;
  refetch: () => void;
}

export const ModalDeleteEntity = <Q, Res>({
  id,
  message,
  entityName,
  deleteEntity,
  refetch,
}: IProps<Q, Res>) => {
  const { closeModal } = useModal();

  const handleDeleteEntity = async (id: string) => {
    try {
      await deleteEntity({ id } as Q).unwrap();
      closeModal();
      refetch();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      // Govnocode follows, beware
      // Try to get error message from various possible locations
      const errorData = error.data || {};
      let errorMessage = '';

      // First, check for error/errors keys and get the first available message
      if (errorData.error) {
        errorMessage =
          typeof errorData.error === 'string'
            ? errorData.error
            : errorData.error.message || Object.values(errorData.error)[0];
      } else if (errorData.errors) {
        errorMessage =
          typeof errorData.errors === 'string'
            ? errorData.errors
            : errorData.errors.message || Object.values(errorData.errors)[0];
      } else if (errorData.message) {
        // Fall back to message key
        errorMessage = errorData.message;
      }

      // Show toast with the found message or default
      toast.error(errorMessage || 'Failed to delete entity');
    }
  };

  const modalConfirmProps = {
    title: entityName ? `Are you sure you want to delete ${entityName}?` : 'Are you sure?',
    message,
    onCancel: closeModal,
    onConfirm: () => handleDeleteEntity(id),
  };

  return <ModalConfirm {...modalConfirmProps} />;
};
